
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import NotificationDialog from './components/NotificationDialog.vue';

export default Vue.extend({
    name: 'App',
    components: {
        NotificationDialog,
    },
    computed: {
        ...mapState('offices', ['corp']),
        ...mapState('properties', ['properties']),
        propertiesMap(): Map<string, any> {
            const propMap = new Map<string, any>();
            if (this.properties) {
                this.properties.forEach((p: {'name': string; 'value': any}) => {
                    propMap.set(p.name, p.value);
                });
            }
            return propMap;
        },
        items() {
            const itemMenu = [
                // { heading: 'Label' },
                {
                    icon: require('@/assets/icons/employees_icon.svg'),
                    text: 'Employees',
                    ref: '/employees',
                },
                {
                    icon: require('@/assets/icons/daily_rides_icon.svg'),
                    text: 'Daily Rides',
                    ref: '/rides',
                },
                {
                    icon: require('@/assets/icons/reports_icon.svg'),
                    text: 'Reports',
                    ref: '/reports',
                },
            ];
            if (this.propertiesMap.get('showToasts')) {
                const toast = {
                    icon: require('@/assets/icons/toasts.svg'),
                    text: 'Toasts',
                    ref: '/toasts',
                };
                itemMenu.push(toast);
            }
            if (this.propertiesMap.get('showSustainabilityReport')) {
                const sustainability = {
                    icon: require('@/assets/icons/earth.svg'),
                    text: 'Sustainability Report',
                    ref: '/sustainability-report',
                };
                itemMenu.push(sustainability);
            }
            return itemMenu;
        },
        fitToWidth(): any {
            const nameSplit = String(this.userName).split(' ');
            const longest = nameSplit.reduce(
                (a, b) => (a.length > b.length ? a : b),
            );
            if (longest.length > 10) {
                return { 'font-size': '12px' };
            }
            if (longest.length > 5) {
                return { 'font-size': '14px' };
            }
            return { 'font-size': '16px' };
        },
        userName(): string {
            return this.$auth?.profile?.name || '';
        },
        userEmail(): string {
            return this.$auth?.profile?.email || '';
        },
        corpLogoSrc(): string {
            if (this.corp?.logo) {
                const lastIndex = this.corp.logo.lastIndexOf('.');
                return `//${this.corp.logo.substr(
                    0,
                    lastIndex,
                )}@5x${this.corp.logo.substr(lastIndex)}`;
            }
            return '';
        },
        routeName(): string {
            if (this.$route?.name) {
                const routes = this.$route.name.split(',');
                if (
                    this.$vuetify.breakpoint.name === 'sm'
                    || this.$vuetify.breakpoint.name === 'xs'
                ) {
                    return routes[0];
                }
                return routes.join(
                    '&nbsp;&nbsp;&nbsp;&#8250&nbsp;&nbsp;&nbsp;',
                );
            }
            return this.$route?.name || '';
        },
    },
    data() {
        return {
            drawer: true,
            mini: true,
        };
    },
    methods: {
        ...mapActions('properties', ['getProperties']),
        logout() {
            this.$auth.logout({ returnTo: window.location.origin });
        },
    },
    created() {
        this.getProperties();
    },
});
